import React from 'react';
import { useParams, Navigate } from 'react-router';
import { CrudPage } from '@/components/shared/crud-page';
import { FLEET_CONFIGS, DISPATCH_CONFIGS, SERVICING_CONFIGS } from './configs';
import { DispatchSchedulePage } from '@/pages/dispatch/schedule';

export function FleetPage() {
  const { entity } = useParams<{ entity: string }>();
  if (!entity || !FLEET_CONFIGS[entity]) return <Navigate to="/dashboard" replace />;
  return <CrudPage config={FLEET_CONFIGS[entity]} />;
}

/** When the route uses a literal segment (e.g. `/dispatch/jobs`) instead of
 *  `:entity`, `useParams` returns no `entity` key. The route can pass
 *  `entityOverride="jobs"` so the component still knows which config to load.
 *  Without this, literal-path routes would always fall through to the
 *  `Navigate to="/dashboard"` line below. */
export function DispatchPage({ entityOverride }: { entityOverride?: string } = {}) {
  const params = useParams<{ entity: string }>();
  const entity = entityOverride ?? params.entity;
  if (entity === 'schedule') return <DispatchSchedulePage />;
  if (!entity || !DISPATCH_CONFIGS[entity]) return <Navigate to="/dashboard" replace />;
  return <CrudPage config={DISPATCH_CONFIGS[entity]} />;
}

export function ServicingPage() {
  const { entity } = useParams<{ entity: string }>();
  if (!entity || !SERVICING_CONFIGS[entity]) return <Navigate to="/dashboard" replace />;
  return <CrudPage config={SERVICING_CONFIGS[entity]} />;
}
